import { createUseStyles } from "react-jss";
import Addicon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ButtonGroup from "@mui/material/ButtonGroup";
import { Button as UIButton, InputLabel } from "@mui/material";
import InputBase from "@mui/material/InputBase";

type Props = {
  value: number;
  onChange: (value: number) => void;
  label?: string;
  isRequired?: boolean;
  disabled?: boolean;
};

function NumberInput({ value, onChange, label, isRequired, disabled }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.inputNumber}>
      <InputLabel className={classes.label}>
        {label}
        {isRequired && " *"}
      </InputLabel>
      <ButtonGroup disableElevation variant="outlined">
        <UIButton
          color="inherit"
          className={`${classes.button} ${classes.firstBtn}`}
          onClick={() => {
            onChange(value - 1 < 0 ? 0 : value - 1);
          }}
          disabled={disabled}
        >
          <RemoveIcon />
        </UIButton>
        <InputBase
          type="text"
          inputProps={{
            min: "0",
            step: "1",
            style: {
              textAlign: "center",
              background: "#fff",
              padding: "0 18px",
            },
          }}
          className={classes.inputClass}
          value={value}
          onChange={(e: any) => {
            onChange(parseInt(e.target.value, 10));
          }}
        />
        <UIButton
          color="inherit"
          className={`${classes.button} ${classes.lastBtn}`}
          onClick={() => {
            onChange(value + 1);
          }}
          disabled={disabled}
        >
          <Addicon />
        </UIButton>
      </ButtonGroup>
    </div>
  );
}

const useStyles = createUseStyles(() => ({
  inputNumber: {
    display: "flex",
    flexDirection: "column",
  },
  inputClass: {
    borderTop: "solid 1px rgba(0,0,0,0.23)",
    borderBottom: "solid 1px rgba(0,0,0,0.23)",
  },
  button: {
    borderColor: "rgba(0,0,0,0.23) !important",
    color: "rgba(0,0,0,0.6) !important",
    "&:hover": {
      borderColor: "rgba(0,0,0,0.5) !important",
      backgroundColor: "rgba(0,0,0,0.04) !important",
    },
  },
  firstBtn: {
    borderRight: "none !important",
  },
  lastBtn: {
    borderLeft: "none !important",
  },
  add: {
    marginTop: "5px !important",
  },
  label: {
    position: "relative",
    fontSize: "14px !important",
    marginBottom: 8,
  },
}));

export default NumberInput;
